import { Controller } from "@hotwired/stimulus";
import { createRoot, type Root } from "react-dom/client";
import React from "react";

import SignUpPage from "src/customer/sign_up_page";
import { rootPath } from "src/routes";

export default class extends Controller {
  private root?: Root;

  connect() {
    this.root = createRoot(this.element);

    this.root.render(this.createAccountComponent())
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
      this.root = undefined;
    }
  }

  private createAccountComponent() {
    return React.createElement(
      SignUpPage, {
        afterSignUpCallback: () => { window.location.assign(rootPath()) },
        hasStickyHeader: true,
      }
    );
  }
}
